export default {
    'footer.link.termsOfService': '服务条款',
    'footer.link.privacyPolicy': '隐私政策',
    'footer.link.support': '支持',
    'footer.link.contacts': '联系我们',
    'footer.copyright': '© 2025 GORILLA ENTERTAINMENT PTE. LTD. 版权所有',
    'footer.relationship':'Gorilla Studio is a key studio within the Crazy Maple Studio publishing family.'
};
